// PHD Components
import Vue from 'vue';
import ClinicalTrialComponent from '@/components/phd/clinical-trial-component.vue';
import PhdCommunitiesEducation from '@/components/phd/communities-education.vue';
import DeviceDrugAlerts from '@/components/phd/device-drug-alerts.vue';
import DailyRateComparison from '@/components/phd/daily-rate-comparison.vue';
import MembershipRateComparison from '@/components/phd/membership-rate-comparison.vue';
import OverallJournalComparison from '@/components/phd/overall-journal.vue';
import PhdLeftNav from '@/components/phd/left-nav.vue';
import PhdNavSecondaryTertiary from '@/components/phd/nav-secondary-tertiary.vue';
import ScienceNewsBox from '@/components/phd/science-news-box.vue';
import MemberTierSelector from '@/components/member-tier-selector.vue';
import PhdDisplayCheckbox from '@/components/phd/phd-display-checkbox.vue';
import PHDEducationActivitiesList from '@/components/phd/education-activities-list.vue';
import RiskCalculator from '@/components/phd/risk-calculator.vue';
import CkmRiskCalculator from '@/components/phd/ckm-risk-calculator.vue';
import HCFCalculator from '@/components/phd/hcf-calculator.vue';
import AhaSearchFundingopportunities from '@/components/phd/aha-search-funding-opportunities.vue';

import ahaSearchDropdown from '@/components/phd/aha-search-dropdown.vue';


Vue.component('clinical-trial-component', ClinicalTrialComponent);
Vue.component('communities-education', PhdCommunitiesEducation);
Vue.component('device-drug-alerts', DeviceDrugAlerts);
Vue.component('daily-rate-comparison', DailyRateComparison);
Vue.component('phd-left-nav', PhdLeftNav);
Vue.component('phd-nav-secondary-tertiary', PhdNavSecondaryTertiary);
Vue.component('science-news-box', ScienceNewsBox);
Vue.component('membership-rate-comparison', MembershipRateComparison);
Vue.component('member-tier-selector', MemberTierSelector);
Vue.component('overall-journal', OverallJournalComparison);
Vue.component('phd-display-checkbox', PhdDisplayCheckbox);
Vue.component('phd-education-activities-list', PHDEducationActivitiesList);
Vue.component('risk-calculator', RiskCalculator);
Vue.component('Ckm-risk-calculator', CkmRiskCalculator);
Vue.component('hcf-calculator', HCFCalculator);


Vue.component('aha-search-funding-opportunities', AhaSearchFundingopportunities);

Vue.component('aha-search-dropdown', ahaSearchDropdown);




// WEBPACK FOOTER //
// ./src/app/phd.js